import React from 'react'

const RecordingCopy = () => (
    <>
        <p>BSK Mastersound can provide services for any stage of the music production process, from recording to mixing to mastering.</p>
        <p>Have a live performance or talk you want recorded? Bruce can bring his gear on location and capture it.</p>
        <p>Want to record in the studio? Bruce has access to a variety of spaces for your recording day. Plus, you can mix and master your recording with Bruce, or take your tracks with you to mix and master elsewhere.</p>
        <p>Have tracks from an existing project that you want mixed and mastered? Or maybe you want to add some overdubs? Either way, Bruce’s home recording and hi-fi system will let you do both.</p>
        <p>Planning to release on CD? LP? Cassette? Bruce can master for all those formats and more.</p>
        <p>To start your inquiry, select a category.</p>
    </>
)

export default RecordingCopy
